import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';

import Modal from '../../../common/modal/Modal';
import {
  getPreventiveTask,
  putPreventiveTaskResource,
} from '../../../../actions/task-schedule/PreventiveTask';

import AddResourcePreventiveTaskForm from './AddResourcePreventiveTaskForm';

export const AddResourcePreventiveTaskButton = ({
  preventiveTaskId,
  dispatchPutPreventiveTaskResource,
  dispatchGetPreventiveTask,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState(null);

  const onModalSubmit = async (formValues) => {
    const newFormValues = {
      companyResourceIdList: [],
      companyResourceGroupIdList: [],
    };

    if (
      formValues.companyResourceId &&
      formValues.companyResourceId.length > 0
    ) {
      newFormValues.companyResourceIdList = formValues.companyResourceId.map(
        (option) => option.value,
      );
    }

    if (
      formValues.companyResourceGroupId &&
      formValues.companyResourceGroupId.length > 0
    ) {
      newFormValues.companyResourceGroupIdList =
        formValues.companyResourceGroupId.map((option) => option.value);
    }

    await dispatchPutPreventiveTaskResource(preventiveTaskId, newFormValues);

    dispatchGetPreventiveTask({
      preventiveTaskId,
    });

    setShowModal(false);
  };

  const onCancel = () => {
    setShowModal(false);
  };

  const onShowModal = () => {
    const newModalBody = (
      <AddResourcePreventiveTaskForm
        onCancel={onCancel}
        handleProcess={onModalSubmit}
      />
    );

    setModalBody(newModalBody);
    setShowModal(true);
  };

  return (
    <>
      <Button color="info" onClick={onShowModal}>
        <i className="fa fa-plus-circle" /> Agregar Recursos
      </Button>

      <Modal
        show={showModal}
        title="Agregar Recursos a la Tarea Preventiva"
        body={modalBody}
        size="lg"
      />
    </>
  );
};

AddResourcePreventiveTaskButton.propTypes = {
  preventiveTaskId: PropTypes.number.isRequired,
  dispatchGetPreventiveTask: PropTypes.func.isRequired,
  dispatchPutPreventiveTaskResource: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchGetPreventiveTask: getPreventiveTask,
  dispatchPutPreventiveTaskResource: putPreventiveTaskResource,
};

export default connect(
  null,
  mapDispatchToProps,
)(AddResourcePreventiveTaskButton);
